import { render, staticRenderFns } from "./BidUrl.vue?vue&type=template&id=5773741b"
import script from "./BidUrl.vue?vue&type=script&lang=js"
export * from "./BidUrl.vue?vue&type=script&lang=js"
import style0 from "./BidUrl.vue?vue&type=style&index=0&id=5773741b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports